/**
 * sourceGrouping - Groups flat Source[] by document_id for display
 */

interface Source {
  id: string;
  content: string;
  similarity: number;
  document_id?: string;
  block_type?: string;
  ref_ids?: number[];
  metadata?: any;
  num?: number;
}

export interface GroupedSource {
  document_id: string;
  title: string;
  report_date: string;
  analyst: string;
  blocks: Source[];
}

export function groupSourcesByDocument(sources: Source[]): GroupedSource[] {
  const groups = new Map<string, GroupedSource>();

  for (const source of sources) {
    const docId = source.document_id || source.metadata?.document_id || 'unknown';
    if (!groups.has(docId)) {
      groups.set(docId, {
        document_id: docId,
        title: source.metadata?.title || 'Untitled',
        report_date: source.metadata?.report_date || '',
        analyst: source.metadata?.analyst || source.metadata?.analysts?.join(', ') || '',
        blocks: [],
      });
    }
    groups.get(docId)!.blocks.push(source);
  }

  // Sort groups by first block's citation number
  return Array.from(groups.values()).sort((a, b) => {
    const aMin = Math.min(...a.blocks.map(b => b.num || 999));
    const bMin = Math.min(...b.blocks.map(b => b.num || 999));
    return aMin - bMin;
  });
}
